import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DescuentoProducto } from '../models/descuento-producto.model';

@Injectable({
    providedIn: 'root'
})
export class DescuentoProductoService {

    constructor(private http: HttpClient) { }

    getDescuentoProducto() {
        return this.http.get<DescuentoProducto>('/calculadora/descuento-producto');
    }

    updateDescuentoProducto(descuentoProducto: DescuentoProducto) {
        return this.http.put<DescuentoProducto>('/calculadora/descuento-producto', descuentoProducto);
    }
}
